<template>
  <SysDialog
    v-model="DIALOG_ATIVO"
    :titulo="`Relatório ${relatorio.title}`"
    txt-botao="Gerar relatório"
    @click:primary="gerarRelatorio"
  >
    <div class="d-flex align-center">
      <div class="w-50-porcento pr-2">
        <SysDatePicker
          v-model="filtros.data_inicial"
          outlined
          titulo_label="Data Inicial"
          :error-messages="DATA_INI_ERRORS"
        />
      </div>

      <div class="w-50-porcento pl-2">
        <SysDatePicker
          v-model="filtros.data_final"
          titulo_label="Data Final"
          outlined
          :error-messages="DATA_FIN_ERRORS"
        />
      </div>
    </div>

    <div class="d-flex align-center mt-n1">
      <div class="w-50-porcento pr-2">
        <SysGrupoAutocomplete
          v-model="filtros.grupos"
          label="Grupos"
          outlined
          multiple
          hide-details
        />
      </div>

      <div class="w-50-porcento pl-2">
        <SysFilialGrupoAutocomplete
          v-model="filtros.filiais"
          label="Filiais"
          outlined
          :ids-grupo="filtros.grupos"
          multiple
          hide-details
          :qtde-visivel-selecionados="3"
        />
      </div>
    </div>

    <div class="d-flex align-center">
      <div class="w-50-porcento pr-2">
        <SysSegmentoAutocomplete
          v-model="filtros.segmentos"
          label="Segmentos"
          outlined
          multiple
          :qtde-visivel-selecionados="1"
        />
      </div>

      <div class="w-50-porcento pl-2">
        <SysFornecedorAutocomplete
          v-model="filtros.fornecedores"
          label="Fornecedores"
          outlined
          multiple
          :ids-segmento="filtros.segmentos"
          class="mt-6 mb-n1"
          :qtde-visivel-selecionados="1"
        />
      </div>
    </div>

    <SysCompradorAutocomplete
      v-model="filtros.compradores"
      label="Compradores"
      outlined
      multiple
      :qtde_visivel_selecionados="1"
    />
    <div class="d-flex align-center">
    </div>

    <div class="d-flex align-center">
    </div>

    <div class="d-flex align-center">
    </div>
  </SysDialog>
</template>

<script>
import $axios from "@/api/api";
import Mixin from "@/components/Relatorios/Mixin";
import { required } from "vuelidate/lib/validators";
import SysDatePicker from '@/components/utils/SysDatePicker.vue';
import SysGrupoAutocomplete from "@/components/utils/crud/SysGrupoAutocomplete";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete";
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete";
import SysCompradorAutocomplete from '@/components/utils/crud/SysCompradorAutocomplete.vue';

export default {
  name: "TotalCompradoPorFilial",
  mixins: [Mixin],
  components: {
    SysFilialGrupoAutocomplete,
    SysGrupoAutocomplete,
    SysDatePicker,
    SysSegmentoAutocomplete,
    SysFornecedorAutocomplete,
    SysCompradorAutocomplete
  },
  data: () => ({
    filtros: {
      grupos: [],
      filiais: [],
      data_inicial: '',
      data_final: '',
      segmentos: [],
      fornecedores: [],
      compradores: []
    }
  }),
  computed: {
    DATA_INI_ERRORS() {
      const errors = [];
      if (!this.$v.filtros.data_inicial.$dirty) return errors;
      !this.$v.filtros.data_inicial.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    DATA_FIN_ERRORS() {
      const errors = [];
      if (!this.$v.filtros.data_final.$dirty) return errors;
      !this.$v.filtros.data_final.required && errors.push("Campo Obrigatório.");
      return errors;
    },
  },
  methods: {
    gerarRelatorio() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      const url = `${this.relatorio.url}${this.Helpers.formatarParametrosObjParaUrl(this.filtros)}`;
      window.open(`${$axios.defaults.baseURL}/${url}`, "_blank");
      this.DIALOG_ATIVO = false;
    }
  },
  validations: {
    filtros: {
      data_inicial: { required },
      data_final: { required },
    }
  }
}
</script>

<style scoped>

</style>
